import { ClockIcon } from '@heroicons/react/24/outline/index.js';
import { formatDateTime } from '../../lib/DateTime.js';

const PendingUntilBanner = ({ pendingUntil, className }) => {
    return (
        <div className={`p-4 bg-yellow-500 text-white rounded-lg mb-4 flex ${className}`}>
            <ClockIcon className="w-6 h-6 mt-0.5 mr-2" />
            Waiting for client payment, holding this until{' '}
            {formatDateTime(pendingUntil)}
        </div>
    );
};

export default PendingUntilBanner;
